/**
 * Sidebar Menu Configuration (Kiosk Portal)
 * All menu items are defined here as constants
 */

import {
  Scan,
  Settings,
  Gauge,
} from '@spcc/uikit'
import type { MenuItem } from './types'

// ============================================
// Main Menu Items
// ============================================

export const MAIN_MENU_ITEMS: MenuItem[] = [
  {
    to: '/scan',
    labelKey: 'sidebar.scan',
    icon: Scan,
  },
  {
    to: '/weighbridge',
    labelKey: 'sidebar.weighbridge',
    icon: Gauge,
    isAdminOnly: true,
  },
]

// ============================================
// No Menu Groups in Kiosk (simple navigation)
// ============================================

export const MENU_GROUPS = []

// ============================================
// No Secondary Menu Items
// ============================================

export const SECONDARY_MENU_ITEMS: MenuItem[] = []

// ============================================
// Bottom Menu Items
// ============================================

export const BOTTOM_MENU_ITEMS: MenuItem[] = [
  {
    to: '/settings',
    labelKey: 'sidebar.settings',
    icon: Settings,
  },
]

// ============================================
// Default Expanded Menu IDs (none for kiosk)
// ============================================

export const DEFAULT_EXPANDED_MENUS: string[] = []

// ============================================
// Sidebar Dimensions
// ============================================

export const SIDEBAR_DIMENSIONS = {
  EXPANDED_WIDTH: 'w-72',
  COLLAPSED_WIDTH: 'w-[72px]',
  MOBILE_WIDTH: 'w-72',
} as const
